export default __webpack_public_path__ + "static/media/18_photo.8ebeffd3.jpg";